/*
 * @Author: Teemo Ding
 * @Date: 2021-10-28 16:58:00
 * @LastEditTime: 2023-05-10 11:38:58
 * @LastEditors: Please set LastEditors
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/SubscriptionBuy/List/config.tsx
 */
import React from 'react';
//import css from './css.module.less';
import StatusTag from './StatusTag';

import { Icon } from '@/src/tools/icon';
import { ESubscriptionBuyStatus } from '@/src/types/common/order';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import {
  fulfillmentStatusesText,
  paymentStatusText,
  statusText,
} from 'src/pages/Order/config';
import { formatMoney } from 'src/tools/helper';
import { EnumTablePosition } from 'src/types/common/common';
export { statusText, paymentStatusText, fulfillmentStatusesText };
export { tabsConfig, filterList, breadcrumbData, columns, tabDict, ETab };

enum ETab {
  all = 'all',
  active = 'active',
  cancelled = 'cancelled',
}

const StatusI18NKeyMapping = {
  [ESubscriptionBuyStatus.Active]:
    'subscriptionBuy.subscriptionBuy.config_List_filterList_Status_dropdownProps_active_label',
  [ESubscriptionBuyStatus.Created]:
    'subscriptionBuy.subscriptionBuy.config_List_filterList_Status_dropdownProps_Created_label',
  [ESubscriptionBuyStatus.Cancelled]:
    'subscriptionBuy.subscriptionBuy.config_List_filterList_Status_dropdownProps_Cancelled_label',
};

const tabDict = {
  [ETab.all]: [
    ESubscriptionBuyStatus.Active,
    ESubscriptionBuyStatus.Created,
    ESubscriptionBuyStatus.Cancelled,
  ],
  [ETab.active]: [ESubscriptionBuyStatus.Active],
  [ETab.cancelled]: [ESubscriptionBuyStatus.Cancelled],
};

const tabsConfig = ({ getI18n }) => [
  //定义tabs列表
  {
    name: getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_tabsConfig_all_name',
    ),
    key: ETab.all,
  },
  {
    name: getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_tabsConfig_active_name',
    ),
    key: ETab.active,
  },
  {
    name: getI18n('subscriptionBuy.subscriptionBuy.config_List_ETab_cancelled'),
    key: ETab.cancelled,
  },
];

const filterList = (salesChannels, { getI18n }) => [
  {
    type: EnumFilterType.SingleSelection,
    dropdownProps: {
      name: getI18n(
        'subscriptionBuy.subscriptionBuy.config_List_filterList_Price_dropdownProps',
      ),
    },
    keyWord: 'priceAlert',
    options: [
      {
        label: getI18n(
          'subscriptionBuy.subscriptionBuy.config_List_filterList_Price_dropdownProps_Yes_label',
        ),
        value: '1',
      },
      {
        label: getI18n(
          'subscriptionBuy.subscriptionBuy.config_List_filterList_Price_dropdownProps_No_label',
        ),
        value: '0',
      },
    ],
  },
  {
    type: EnumFilterType.MultipleSelection,

    dropdownProps: {
      name: getI18n(
        'subscriptionBuy.subscriptionBuy.config_List_filterList_SalesChannel_dropdownProps',
      ),
    },
    keyWord: 'salesChannelUuids',
    options: salesChannels.map((item) => ({
      label: item.name,
      value: item.uuid,
    })),
  },
  {
    type: EnumFilterType.MultipleSelection,
    dropdownProps: {
      name: getI18n(
        'subscriptionBuy.subscriptionBuy.config_List_filterList_Status_dropdownProps',
      ),
    },
    keyWord: 'orderStatuses',
    options: [
      {
        label: getI18n(
          'subscriptionBuy.subscriptionBuy.config_List_filterList_Status_dropdownProps_active_label',
        ),
        value: ESubscriptionBuyStatus.Active,
      },
      {
        label: getI18n(
          'subscriptionBuy.subscriptionBuy.config_List_filterList_Status_dropdownProps_Cancelled_label',
        ),
        value: ESubscriptionBuyStatus.Cancelled,
      },
      {
        label: getI18n(
          'subscriptionBuy.subscriptionBuy.config_List_filterList_Status_dropdownProps_Created_label',
        ),
        value: ESubscriptionBuyStatus.Created,
      },
    ],
  },
];

const breadcrumbData = ({ getI18n }) => [
  {
    url: '',
    name: getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_breadcrumbData_home_name',
    ),
  },
  {
    url: '',
    name: getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_breadcrumbData_Order_name',
    ),
  },
  {
    url: '',
    name: getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_breadcrumbData_cart_name',
    ),
  },
];

const columns = (timezoneInUTC, reportingCurrency, currency, { getI18n }) => [
  {
    title: getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_columns_Subscription_title',
    ),
    textTitle: getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_columns_Subscription_title',
    ),
    dataIndex: 'subscriptionBuyId',
    key: 'subscriptionBuyId',
    default: true,
    optional: false,
    sorter: true,
    childGenerate: (text, record) => (
      <NoWrapContainer>
        <GlobalTooltip title={text}>{text}</GlobalTooltip>
      </NoWrapContainer>
    ),
    minWidth: 160,
  },
  {
    title: `${getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_columns_Created_title',
    )} (UTC ${timezoneInUTC})`,
    textTitle: getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_columns_Created_title',
    ),
    dataIndex: 'createdDate',
    default: true,
    optional: true,
    sorter: true,
    childGenerate: (text, record) => (
      <NoWrapContainer>
        <GlobalTooltip title={text}>{text}</GlobalTooltip>
      </NoWrapContainer>
    ),
    key: 'createdDate',
    minWidth: 160,
  },
  {
    title: getI18n(
      'allOrders.orderDetail.components_collection_pin_buyerchild',
    ),
    dataIndex: 'buyerName',
    default: true,
    optional: true,
    sorter: true,
    childGenerate: (text, record) => (
      <NoWrapContainer>
        <GlobalTooltip title={text}>{text}</GlobalTooltip>
      </NoWrapContainer>
    ),
    key: 'buyerName',
    minWidth: 144,
  },
  {
    title: getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_columns_total_title',
    ),
    dataIndex: 'totalPrice',
    key: 'totalPrice',
    default: true,
    optional: true,

    childGenerate: (text, record) => {
      const { currencyCode } = record;
      const price = formatMoney(text);
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>
            {currencyCode || ''}
            {` ${price}`}
          </GlobalTooltip>
        </NoWrapContainer>
      );
    },
    minWidth: 120,
  },
  {
    title: getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_columns_currency_title',
    ),
    dataIndex: 'reportingTotalPrice',
    key: 'reportingTotalPrice',
    default: true,
    optional: true,

    childGenerate: (text, record) => {
      const price = formatMoney(text);
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>
            {reportingCurrency || ''}
            {` ${price}`}
          </GlobalTooltip>
        </NoWrapContainer>
      );
    },
    width: 138,
  },
  {
    titleGenerate: () => (
      <div>
        {getI18n(
          'subscriptionBuy.subscriptionBuy.config_List_columns_Alert_title',
        )}
      </div>
    ),
    textTitle: getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_columns_Alert_title',
    ),
    dataIndex: 'priceAlert',
    key: 'priceAlert',
    default: true,
    optional: true,
    sorter: true,
    position: EnumTablePosition.mid,
    childGenerate: (text, record) => {
      const { priceAlert } = record;
      if (priceAlert) {
        return (
          <Icon
            type='iconinfo1'
            style={{
              fontSize: 16,
              width: '16px',
              height: '16px',
              color: '#fa5151',
            }}
          />
        );
      } else {
        return null;
      }
    },
    minWidth: 108,
  },
  {
    title: getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_columns_saleschannel_title',
    ),
    dataIndex: 'salesChannelName',
    key: 'salesChannelName',
    default: true,
    optional: true,
    sorter: true,
    //position: EnumTablePosition.mid,
    childGenerate: (text, record) => {
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>{text}</GlobalTooltip>
        </NoWrapContainer>
      );
    },
    minWidth: 120,
  },
  {
    title: getI18n(
      'subscriptionBuy.subscriptionBuy.config_List_columns_status_title',
    ),
    dataIndex: 'status',
    key: 'status',
    default: true,
    optional: true,
    //sorter: true,
    //position: EnumTablePosition.mid,
    childGenerate: (text, record) => {
      return (
        <StatusTag status={text} label={getI18n(StatusI18NKeyMapping[text])} />
      );
    },
    minWidth: 90,
  },
  //StatusTag
];
